<div class="hierarchical-data">
  @if (data?.length > 0) {
    @if (headings) {
      <div class="flex">
        @for (heading of headings; track heading) {
          <div
            class="hierarchical-data__heading flex__child text--label"
            [class]="
              (!!heading.span ? 'flex__child-' + heading.span : '') +
              'hierarchical-data__heading-' +
              heading.id +
              ' ' +
              heading.class
            "
            [attr.data-test]="'hierarchical-data__heading-' + heading.id"
          >
            {{ heading.value }}
          </div>
        }
      </div>
    }
    @for (row of data; track row) {
      <div
        class="flex hierarchical-data__row"
        [ngClass]="{ 'hierarchical-data__row--no-border': row.type === rowTypes.title }"
        [class]="row.level ? 'hierarchical-data__row--l' + row.level : ''"
      >
        @for (col of row.columns; track col; let isLast = $last) {
          @if (row.type === rowTypes.title) {
            <div
              [class]="
                'hierarchical-data__title flex__child ' +
                'hierarchical-data__title-' +
                col.id +
                ' ' +
                (!!col.span ? ' flex__child-' + col.span + ' ' : '') +
                (isLast && !row.level ? ' flex flex--align-center ' : '') +
                (!row.level ? ' hierarchical-data__title--large ' : '') +
                'text--bold'
              "
              [attr.data-test]="'hierarchical-data__title-' + col.id"
            >
              <ng-container
                *ngTemplateOutlet="column; context: { col: col, row: row }"
              ></ng-container>
              @if (isLast && !row.level) {
                <span
                  class="hierarchical-data__divider spacing--margin-left flex__child--auto"
                ></span>
              }
            </div>
          }
          @if (row.type === rowTypes.header) {
            <div
              class="hierarchical-data__header flex__child color--primary-300 text--bold"
              [ngClass]="'hierarchical-data__header-' + col.id"
              [attr.data-test]="'hierarchical-data__header-' + col.id"
              [class]="!!col.span ? 'flex__child-' + col.span : ''"
            >
              <ng-container
                *ngTemplateOutlet="column; context: { col: col, row: row }"
              ></ng-container>
            </div>
          }
          @if (row.type === rowTypes.spacer) {
            <div
              class="hierarchical-data__spacer flex__child"
              [ngClass]="'hierarchical-data__spacer-' + col.id"
              [attr.data-test]="'hierarchical-data__header-' + col.id"
              [class]="!!col.span ? 'flex__child-' + col.span : ''"
            >
              <ng-container
                *ngTemplateOutlet="column; context: { col: col, row: row }"
              ></ng-container>
            </div>
          }
          @if (
            row.type !== rowTypes.title &&
            row.type !== rowTypes.header &&
            row.type !== rowTypes.spacer &&
            row.type !== rowTypes.footer
          ) {
            <div
              class="hierarchical-data__column flex__child"
              [ngClass]="'hierarchical-data__column-' + col.id"
              [attr.data-test]="'hierarchical-data__column-' + col.id"
              [class]="!!col.span ? 'flex__child-' + col.span : ''"
            >
              <ng-container
                *ngTemplateOutlet="column; context: { col: col, row: row }"
              ></ng-container>
            </div>
          }
          @if (row.type === rowTypes.footer) {
            <div
              class="hierarchical-data__footer flex__child color--primary-300 text--bold"
              [ngClass]="'hierarchical-data__footer-' + col.id"
              [attr.data-test]="'hierarchical-data__footer-' + col.id"
              [class]="!!col.span ? 'flex__child-' + col.span : ''"
            >
              <ng-container
                *ngTemplateOutlet="column; context: { col: col, row: row }"
              ></ng-container>
            </div>
          }
        }
        <ng-template #column let-col="col" let-row="row">
          <div
            [class]="'hierarchical-data__column-inner ' + col.class"
            [ngClass]="{ 'text--right': col.type && col.type !== colTypes.string }"
          >
            @if (!col?.type || col.type === colTypes.string) {
              {{ col.value }}
            }
            @if (col.type === colTypes.number) {
              {{ col.value | agrNumber: col?.digitsInfo }}
            }
            @if (col.unit) {
              <span>{{ col.unit }}</span>
            }
            @if (col.type === colTypes.currency) {
              {{ col.value | agrCurrency: col?.currencyKeyColumn : 'symbol-narrow' }}
            }
            @if (col.type === colTypes.date) {
              {{ col.value | agrDate: 'shortDate' }}
            }
          </div>
        </ng-template>
      </div>
    }
  }

  <agr-notification-empty
    data-test="hierarchical-data__empty"
    [isEmpty]="!!isEmpty || !data?.length"
    [emptyTitle]="emptyTitle"
    [emptyDescription]="emptyDescription"
    [emptyImage]="emptyImage"
    [emptyActionIcon]="emptyActionIcon"
    [emptyActionText]="emptyActionText"
    [emptyActionColor]="emptyActionColor"
    [showEmptyAction]="showEmptyAction"
    (emptyAction)="emptyAction.emit($event)"
    class="spacing--margin-top"
  ></agr-notification-empty>
</div>
